export default "__VITE_PUBLIC_ASSET__9756a9d7__"